module.exports = __webpack_public_path__ + "img/lang-8.b0e2a508.jpg";